"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "app-nicklist",
    class: {
      'app-nicklist--filtering': _vm.userFilterVisible,
      'app-nicklist--avatars': _vm.shouldShowAvatars
    }
  }, [_c('div', {
    staticClass: "app-nicklist-online"
  }, [_c('span', {
    staticClass: "app-nicklist-online-count"
  }, [_vm._v(_vm._s(_vm.displayedUsersCount))]), _c('span', {
    staticClass: "app-nicklist-online-label"
  }, [_vm._v("utilisateurs en ligne")])]), _c('div', {
    staticClass: "app-nicklist-header"
  }, [_c('div', {
    staticClass: "app-nicklist-filter",
    on: {
      "click": _vm.toggleUserFilter
    }
  }, [_c('i', {
    staticClass: "fa fa-search",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.userFilter,
      expression: "userFilter"
    }],
    ref: "user_filter",
    attrs: {
      "placeholder": "Pseudo, sexe, âge, lieu..."
    },
    domProps: {
      "value": _vm.userFilter
    },
    on: {
      "click": function ($event) {
        $event.stopPropagation();
      },
      "blur": _vm.onFilterBlur,
      "input": function ($event) {
        if ($event.target.composing) return;
        _vm.userFilter = $event.target.value;
      }
    }
  })])]), _vm.selfUser ? _c('div', {
    staticClass: "app-nicklist-selfcard"
  }, [_c('nicklist-user', {
    key: `self-${_vm.aslRefresh}`,
    attrs: {
      "user": _vm.selfUser,
      "nicklist": _vm.self,
      "network": _vm.network
    }
  })], 1) : _vm._e(), _c('RecycleScroller', {
    staticClass: "app-nicklist-users",
    attrs: {
      "items": _vm.sortedUsers,
      "item-size": _vm.shouldShowAvatars ? 62 : 46,
      "key-field": 'id'
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function ({
        item
      }) {
        return [_c('nicklist-user', {
          key: item.id,
          attrs: {
            "user": item,
            "nicklist": _vm.self,
            "network": _vm.network
          }
        })];
      }
    }])
  })], 1);
};
var staticRenderFns = exports.staticRenderFns = [];